import { render, staticRenderFns } from "./UploadResource.vue?vue&type=template&id=1302e824"
import script from "./UploadResource.vue?vue&type=script&lang=js"
export * from "./UploadResource.vue?vue&type=script&lang=js"
import style0 from "./UploadResource.vue?vue&type=style&index=0&id=1302e824&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports